import BaseService from './BaseService';
import jwt_decode from 'jwt-decode';

export default class AuthService extends BaseService {
  /**
   * Exchanges a Clearlogin or Azure AD token for an app token (or uses the stored app token)
   * @param jwt
   * @returns {object} authObj
   */
  static async doTokenAuthentication(jwt) {
    let accessTokens = null;
    let authObj = null;
    try {
      const authInfo = jwt_decode(jwt);
      const issuer = authInfo.iss?.toUpperCase();
      switch (issuer) {
        case 'CLEARLOGIN':
          accessTokens = await this.getRequest(`sms/token/exchange/clearlogin?jwt=${jwt}`);
          break;
        case 'EVOLVEMESSAGING':
          accessTokens = {
            authenticationToken: jwt,
            applicationToken: jwt,
            authTokenType: 'EVOLVEMESSAGING'
          };
          break;
        default:
          accessTokens = await this.getRequest(`sms/token/exchange/azure?jwt=${jwt}`);
          break;
      }
      if (accessTokens.applicationToken) {
        const tokenUser = jwt_decode(accessTokens.applicationToken);
        authObj = {
          userId: tokenUser.userId,
          token: accessTokens.applicationToken
        }
      }
    } catch (e) {
      console.error(`[AuthService.js] Invalid / Malformed token provided`);
      console.error(e.message);
    }

    return authObj;
  }

  /**
   * Checks the current event subscriptions for a user and subscribes to any missing subscription types
   * @param phoneNumber
   * @returns {Promise<void>}
   */
  static async subscribe(phoneNumber) {
    const requiredSubscriptionTypes = ['send', 'receive', 'read', 'progress', 'delete', 'change'];
    let currentSubscriptions = null;
    let hasAllSubscriptions = false;
    currentSubscriptions = await this.getRequest(`sms/subscriptions/number/${phoneNumber}`);
    if (currentSubscriptions) {
      const currentSubscriptionTypes = currentSubscriptions.map(sub => sub.subscriptionType);
      hasAllSubscriptions = requiredSubscriptionTypes.every(subType => {
        return currentSubscriptionTypes.includes(subType);
      });
    }
    if (hasAllSubscriptions === false) {
      this.postRequest(`sms/subscriptions/number/${phoneNumber}`, {
        subscriptions: currentSubscriptions || []
      });
    }
  }

}
